<script>
import axios from "axios";
import { myMixinDateTimestamp } from "@/mixinOld";
import Cookies from "js-cookie";
import { MaskInput } from "vue-3-mask";
import validatePass from "@/directives/validatePass.js";
import validatePhone from "@/directives/validatePhone.js";
export default {
  name: "RegisterBlock",
  directives: {
    validatePass,
    validatePhone,
  },
  components: {
    MaskInput,
  },
  mixins: [myMixinDateTimestamp],
  data() {
    return {
      user: this.$store.getters.getUser,
      user2: null,
      apiUrl: this.$store.getters.getApiUrl,
      apiDomain: this.$store.getters.getApiDomain,
      role: null,
      etapR: 4.2,
      city: {
        flag: false,
        items: [],
        item: null,
        id: null,
      },
      school: {
        flag: false,
        items: [],
        item: null,
        id: null,
      },
      college: {
        flag: false,
        items: [],
        item: null,
        id: null,
      },
      university: {
        flag: false,
        items: [],
        item: null,
        id: null,
      },
      etap3: false,
      schools: [],
      colleges: [],
      universities: [],
      inputUsername: "",
      inputPassword: "",
      inputPassword2: "",
      familiya: "",
      imya: "",
      otchestvo: "",
      universitie: "",
      job: "",
      jobStartDate: "",
      jobPosition: "",
      defaultFlag: {
        icon: require("@/assets/image/icons/RU.svg"),
        name: "RU",
      },
      allFlags: [
        {
          icon: require("@/assets/image/icons/RU.svg"),
          name: "RU",
          mask: "+7(###) ###-##-##",
          regex: /^\+7\(\d{3}\) \d{3}-\d{2}-\d{2}$/,
        },
        {
          icon: require("@/assets/image/icons/BY.svg"),
          name: "BY",
          mask: "+375(##) ###-##-##",
          regex: /^\+375\(\d{2}\) \d{3}-\d{2}-\d{2}$/,
        },
        {
          icon: require("@/assets/image/icons/KZ.svg"),
          name: "KZ",
          mask: "+7(###) ###-##-##",
          regex: /^\+7\(\d{3}\) \d{3}-\d{2}-\d{2}$/,
        },
      ],
      currentMask: "+7(###) ###-##-##",
      currentRegex: /^\+7\(\d{3}\) \d{3}-\d{2}-\d{2}$/,
      isValidPhone: false,
      dateEnd: "",
      dateStart: "",
      
    };
  },
  methods: {
    registerUser() {
      // let time = Cookies.get("time_onpage");
      // let localTime = new Date().getTime();

      let params = {
        action: "users/register",
        method: "POST",
        body: {
          username: this.inputUsername,
          password: this.inputPassword,
          role: "specialist",
          email: this.inputUsername + "@mail.ru",
        },
      };
      let formData = new FormData();
      for (let key in params) {
        formData.append(key, params[key]);
      }
      formData.append("body[username]", this.inputUsername);
      formData.append("body[password]", this.inputPassword);
      formData.append("body[role]", "specialist");
      axios
        .post(this.apiUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.status) {
            this.user2 = response.data;
            Cookies.set("user", JSON.stringify(this.user2));

            this.$emit("goWellDone");
          } else {
            alert(
              "Такой пользователь уже существует или не верно введены данные"
            );
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },

    setRoleR() {
      let items = document.querySelectorAll(".role__itemR");
      items.forEach((item) => {
        if (item.classList.contains("active")) {
          this.role = item.textContent;
        }
      });

      this.etapR = 2;
    },
    toogleActive(event) {
      let items = document.querySelectorAll(".role__itemR");
      let role = event.currentTarget.dataset.role;

      this.role = role;
      items.forEach((item) => {
        item.classList.remove("active");
      });
      event.currentTarget.classList.toggle("active");
    },
    flagToogle() {
      document.querySelector(".flagList").classList.toggle("active");
    },
    setFlag(flag) {
      document.querySelector(".flagList").classList.remove("active");
      this.defaultFlag = flag;
      this.currentMask = flag.mask;
      this.currentRegex = flag.regex;
    },
    updatePhoneValidity(isValid) {
      this.isValidPhone = isValid;
    },
    updatePasswordValidity(isValid) {
      console.log("Пароль валиден:", isValid);
    },
    updatePassword2Validity(event) {
      let pass = event.currentTarget;

      if (this.inputPassword2 != this.inputPassword) {
        pass.style.borderColor = "red";
        this.etap3 = false;
      } else {
        pass.style.borderColor = "green";
        this.etap3 = true;
      }
    },
    goEtap3() {
      if (this.etap3) {
        this.registerUser();
      } else {
        alert("Пароли не совпадают");
      }
    },
    goEtap4() {
      if (this.familiya != "" && this.imya != "") {
        this.etapR = 4;
      } else {
        alert("Заполните все поля");
        let inputs = document.querySelectorAll("second__etap-3");
        inputs.forEach((input) => {
          input.style.borderColor = "red";
          input.addEventListener("input", () => {
            input.style.borderColor = "transparent";
          });
        });
        return;
      }
      this.checkPut();
    },
    goEtap(etap) {
      let link = "specialist-education-";
      if (etap == 4.2) {
        link += "schools";
      }
      if (etap == 4.3) {
        link += "colleges";
      }
      if (etap == 5) {
        link += "universities";
      }

      let params = {
        action: link,
        method: "POST",
        token: this.user2.bearer, 
      };
      let formData = new FormData();
      for (let key in params) {
        formData.append(key, params[key]);
      }

      formData.append("body[specialist_id]", this.user2.id);
      if (etap == 4.2) {
        formData.append("body[school_id]", this.school.id);
      }
      if (etap == 4.3) {
        formData.append("body[college_id]", this.college.id);
      }
      if (etap == 5) {
        formData.append("body[university_id]", this.university.id);
      }
      formData.append("body[start_date]", this.dateToTimestamp(this.dateStart));
      formData.append("body[end_date]", this.dateToTimestamp(this.dateEnd));
    
      axios
        .post(this.apiUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          this.etapR = etap;
          this.dateStart = "";
          this.dateEnd = "";
        })
        .catch((error) => {
          console.error(error);
        });
    },
    checkPut() {
      let params = {
        action: "user-profiles/" + this.user2.profile.id,
        method: "PUT",
        token: this.user2.bearer,
      };
      let formData = new FormData();
      for (let key in params) {
        formData.append(key, params[key]);
      }
      formData.append("body[f]", this.familiya);
      formData.append("body[i]", this.imya);
      formData.append("body[o]", this.otchestvo);
      axios
        .post(this.apiUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          this.etapR = 4;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    postSchoolUser() {
      let params = {
        action: " user-to-schools",
        method: "POST",
        token: this.user2.bearer,
      };

      let formData = new FormData();
      for (let key in params) {
        formData.append(key, params[key]);
      }

      formData.append("body[school_id]", this.schoolId);
      formData.append("body[user_id]", 27);
      axios
        .post(this.apiUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          this.etapR = 5;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    goWellDone() {
      
      
        this.etapR = 4;
        this.$emit("goWellDone");
      
    },
    getCityes() {
      let params = {
        action: "schools",
        method: "GET",
        token: this.user2.bearer,
      };
      let formData = new FormData();
      for (let key in params) {
        formData.append(key, params[key]);
      }
      axios
        .post(this.apiUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.schools = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getSortCity(event) {
      let inputValue = event.target.value.trim();

      let params = {
        action: "hints/city?str=" + inputValue,
        method: "GET",
        token:
          this.user2.bearer,
      };

      if (inputValue.length >= 3) {
        axios
          .post(this.apiUrl, params, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.city.items = response.data;
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    selectCity(selectedCity, id) {
      // Устанавливаем выбранную школу в инпут и очищаем список
      this.city.name = selectedCity;
      this.city.id = id;
      this.city.flag = true;
      this.city.items = [];
    },
    getSortSchool(event) {
      let inputValue = event.target.value.trim();
      let params = {
        action: "hints/school?str=" + encodeURI(inputValue) + "&city_id=1",
        method: "GET",
        token:
          this.user2.bearer,
      };

      if (inputValue.length >= 3) {
        axios
          .post(this.apiUrl, params, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.school.items = response.data;
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    selectSchool(selectedSchool, id) {
      // Устанавливаем выбранную школу в инпут и очищаем список
      this.school.name = selectedSchool;
      this.school.id = id;
      this.school.items = [];
    },
    getSortCollege(event) {
      let inputValue = event.target.value.trim().toLowerCase();

      let params = {
        action: "hints/college?str=" + encodeURI(inputValue) + "&city_id=1",
        method: "GET",
        token:
          this.user2.bearer,
      };

      if (inputValue.length >= 3) {
        axios
          .post(this.apiUrl, params, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.college.items = response.data;
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    selectCollege(selectedCollege, id) {
      this.college.name = selectedCollege;
      this.college.id = id;
      this.college.items = [];
    },
    getSortUniversity(event) {
      let inputValue = event.target.value.trim().toLowerCase();

      let params = {
        action: "hints/university?str=" + encodeURI(inputValue) + "&city_id=1",
        method: "GET",
        token:
          this.user2.bearer,
      };

      if (inputValue.length >= 3) {
        axios
          .post(this.apiUrl, params, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.university.items = response.data;
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    selectUniversity(selectedUniversitie, id) {
      this.university.name = selectedUniversitie;
      this.university.id = id;
      this.university.items = [];
    },
  },
  mounted() {
    this.etapR = 1;
  },
};
</script>

<template>
  <div v-if="etapR == 1" class="etaps registerEtaps">
    <div class="first__etap">
      <div class="head-h2">Выберите роль</div>
      <div class="role__items">
        <div
          @click="toogleActive"
          data-role="specialist"
          class="role__item role__itemR"
        >
          Специалист
        </div>
        <div
          @click="toogleActive2"
          class="role__item notUse role__itemR default"
        >
          Компания
        </div>
        <div @click="toogleActive2" class="role__item notUse role__itemR">
          Образование
        </div>
        <div @click="toogleActive2" class="role__item notUse role__itemR">
          HR-агент
        </div>
      </div>
      <div @click="setRoleR" class="etaps__btn etaps__btnR">
        Вперед
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g class="icon" opacity="0.4">
            <path
              d="M11.6797 14.62L14.2397 12.06L11.6797 9.5"
              stroke="white"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4 12.0596H14.17"
              stroke="white"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <path
            class="circle"
            d="M12 4C16.42 4 20 7 20 12C20 17 16.42 20 12 20"
            stroke="white"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            class="line"
            d="M20.5 4V20.25"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </div>
    </div>
  </div>
  <div v-if="etapR == 2" class="second__etap">
    <div class="head-h2">Регистрация</div>
    <div class="form">
      <div class="form__item">
        <div class="form__label">Номер телефона</div>
        <MaskInput
          v-validate-phone="{
            regex: currentRegex,
            callback: updatePhoneValidity,
          }"
          v-model="inputUsername"
          class="form__input phone-input"
          :mask="currentMask"
        />
        <div class="flags__wrapper">
          <div class="flags">
            <div @click="flagToogle" class="default">
              <img :src="defaultFlag.icon" alt="" />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
              >
                <path
                  d="M12.45 5.59375L8.37505 9.66875C7.8938 10.15 7.1063 10.15 6.62505 9.66875L2.55005 5.59375"
                  stroke="#1A1A1A"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="flagList">
              <div
                v-for="flag in allFlags"
                :key="flag"
                @click="setFlag(flag)"
                class="flag_item"
              >
                <img :src="flag.icon" alt="" />
                <span>{{ flag.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form__item">
        <div class="form__label">Введите пароль</div>
        <input
          v-validate-pass="updatePasswordValidity"
          v-model="inputPassword"
          class="form__input phone-input"
          :mask="currentMask"
          type="password"
        />
      </div>
      <div class="form__item">
        <div class="form__label">Повторите пароль</div>
        <input
          @input="updatePassword2Validity"
          v-model="inputPassword2"
          class="form__input passR-input"
          :mask="currentMask"
          type="password"
        />
      </div>
    </div>
    <div class="etaps__btn" @click="goEtap3">
      Следующий шаг
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M14.6597 5.92993L20.7297 11.9999L14.6597 18.0699"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.4"
          d="M3.72949 12H20.5595"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- <div class="etapsPagination">01/08</div> -->
  </div>
  <!-- <div v-if="etapR == 3" class="second__etap second__etap-3">
    <div class="head-h2">Регистрация</div>
    <div class="form">
      <div class="form__item">
        <div class="form__label">Введите фамилию<t class="red">*</t></div>
        <input
          v-model="familiya"
          class="form__input phone-input"
          :mask="currentMask"
          type="text"
        />
      </div>
      <div class="form__item">
        <div class="form__label">Введите имя<t class="red">*</t></div>
        <input
          v-model="imya"
          class="form__input phone-input"
          :mask="currentMask"
          type="text"
        />
      </div>
      <div class="form__item">
        <div class="form__label">Введите отчество<t class="red">*</t></div>
        <input
          v-model="otchestvo"
          class="form__input phone-input"
          :mask="currentMask"
          type="text"
        />
      </div>
    </div>
    <div class="etaps__btn" @click="goEtap4">
      Следующий шаг
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M14.6597 5.92993L20.7297 11.9999L14.6597 18.0699"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.4"
          d="M3.72949 12H20.5595"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="etapsPagination">02/08</div>
  </div>
  <div v-if="etapR == 4" class="second__etap">
    <div class="head-h2">Регистрация</div>
    <div class="form">
      <div class="form__item item_sublinks">
        <div class="form__label">Город учреждения<t class="red">*</t></div>
        <input
          v-model="city.name"
          @input="getSortCity"
          class="form__input city-input"
          type="text"
        />
        <div class="school_items" :class="{ active: city.items.length > 0 }">
          <div class="school_itemWrap">
            <div
              v-for="city in city.items"
              :key="city.id"
              class="school_item"
              @click="selectCity(city.name, city.id)"
            >
              {{ city.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="form__item item_sublinks">
        <div class="form__label">Начальное образование<t class="red">*</t></div>
        <input
          v-model="school.name"
          :disabled="!city.flag"
          @input="getSortSchool"
          class="form__input phone-input"
          type="text"
        />
        <div class="school_items" :class="{ active: school.items.length > 0 }">
          <div class="school_itemWrap">
            <div
              v-for="schoolItem in school.items"
              :key="schoolItem.id"
              class="school_item"
              @click="selectSchool(schoolItem.name, schoolItem.id)"
            >
              {{ schoolItem.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="form__item--row">
        <div class="form__item">
          <div class="form__label">Начало<t class="red">*</t></div>
          <MaskInput
            v-model="dateStart"
            :disabled="!city.flag"
            class="form__input phone-input"
            :mask="'##.##.####'"
            type="text"
          />
        </div>
        <div class="form__item">
          <div class="form__label">Окончание<t class="red">*</t></div>
          <MaskInput
            v-model="dateEnd"
            :disabled="!city.flag"
            class="form__input phone-input"
            :mask="'##.##.####'"
            type="text"
          />
        </div>
      </div>
    </div>
    <div class="etaps__btn" @click="goEtap(4.2)">
      Следующий шаг
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M14.6597 5.92993L20.7297 11.9999L14.6597 18.0699"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.4"
          d="M3.72949 12H20.5595"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="etapsPagination">04.1/08</div>
  </div>
  <div v-if="etapR == 4.2" class="second__etap">
    <div class="head-h2">Регистрация</div>
    <div class="form">
      <div class="form__item item_sublinks">
        <div class="form__label">Город учреждения<t class="red">*</t></div>
        <input
          v-model="city.name"
          @input="getSortCity"
          class="form__input city-input"
          type="text"
        />
        <div class="school_items" :class="{ active: city.items.length > 0 }">
          <div class="school_itemWrap">
            <div
              v-for="city in city.items"
              :key="city.id"
              class="school_item"
              @click="selectCity(city.name, city.id)"
            >
              {{ city.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="form__item item_sublinks">
        <div class="form__label">Среднее образование<t class="red">*</t></div>
        <input
          v-model="college.name"
          :disabled="!city.flag"
          @input="getSortCollege"
          class="form__input phone-input"
          type="text"
        />
        <div class="school_items" :class="{ active: college.items.length > 0 }">
          <div class="school_itemWrap">
            <div
              v-for="collegeItem in college.items"
              :key="collegeItem.id"
              class="school_item"
              @click="selectCollege(collegeItem.name, collegeItem.id)"
            >
              {{ collegeItem.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="form__item--row">
        <div class="form__item">
          <div class="form__label">Начало<t class="red">*</t></div>
          <MaskInput
            v-model="dateStart"
            :disabled="!city.flag"
            class="form__input phone-input"
            :mask="'##.##.####'"
            type="text"
          />
        </div>
        <div class="form__item">
          <div class="form__label">Окончание<t class="red">*</t></div>
          <MaskInput
            v-model="dateEnd"
            :disabled="!city.flag"
            class="form__input phone-input"
            :mask="'##.##.####'"
            type="text"
          />
        </div>
      </div>
    </div>
    <div class="etaps__btn" @click="goEtap(4.3)">
      Следующий шаг
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M14.6597 5.92993L20.7297 11.9999L14.6597 18.0699"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.4"
          d="M3.72949 12H20.5595"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="etapsPagination">04.2/08</div>
  </div>
  <div v-if="etapR == 4.3" class="second__etap">
    <div class="head-h2">Регистрация</div>
    <div class="form">
      <div class="form__item item_sublinks">
        <div class="form__label">Город учреждения<t class="red">*</t></div>
        <input
          v-model="city.name"
          @input="getSortCity"
          class="form__input city-input"
          type="text"
        />
        <div class="school_items" :class="{ active: city.items.length > 0 }">
          <div class="school_itemWrap">
            <div
              v-for="city in city.items"
              :key="city.id"
              class="school_item"
              @click="selectCity(city.name, city.id)"
            >
              {{ city.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="form__item item_sublinks">
        <div class="form__label">Высшее образование<t class="red">*</t></div>
        <input
          v-model="university.name"
          :disabled="!city.flag"
          @input="getSortUniversity"
          class="form__input phone-input"
          type="text"
        />
        <div class="school_items" :class="{ active: university.items.length > 0 }">
          <div class="school_itemWrap">
            <div
              v-for="universityItem in university.items"
              :key="universityItem.id"
              class="school_item"
              @click="selectUniversity(universityItem.name, universityItem.id)"
            >
              {{ universityItem.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="form__item--row">
        <div class="form__item">
          <div class="form__label">Начало<t class="red">*</t></div>
          <MaskInput
            v-model="dateStart"
            :disabled="!city.flag"
            class="form__input phone-input"
            :mask="'##.##.####'"
            type="text"
          />
        </div>
        <div class="form__item">
          <div class="form__label">Окончание<t class="red">*</t></div>
          <MaskInput
            v-model="dateEnd"
            :disabled="!city.flag"
            class="form__input phone-input"
            :mask="'##.##.####'"
            type="text"
          />
        </div>
      </div>
    </div>
    <div class="etaps__btn" @click="goEtap(5)">
      Следующий шаг
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M14.6597 5.92993L20.7297 11.9999L14.6597 18.0699"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.4"
          d="M3.72949 12H20.5595"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="etapsPagination">04.3/08</div>
  </div>
  <div v-if="etapR == 5" class="second__etap">
    <div class="head-h2">Регистрация</div>
    <div class="form">
      <div class="form__item">
        <div class="form__label">
          Место работы
          
        </div>
        <input
          v-model="job"
          class="form__input phone-input"
          :mask="currentMask"
          type="text"
        />
      </div>
      <div class="form__item">
        <div class="form__label">
          Начало работы
         
        </div>
        <MaskInput
          v-model="jobStartDate"
          class="form__input phone-input"
          :mask="'##.##.####'"
          placeholder="__.__.____"
        />
      </div>
      <div class="form__item">
        <div class="form__label">
          Ваша должность
         
        </div>
        <input
          v-model="jobPosition"
          class="form__input phone-input"
          :mask="currentMask"
          type="text"
        />
      </div>
    </div>
    <div class="etaps__btn" @click="goWellDone">
      Следующий шаг
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M14.6597 5.92993L20.7297 11.9999L14.6597 18.0699"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.4"
          d="M3.72949 12H20.5595"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="etapsPagination">04/04</div>
  </div> -->
</template>
<style scoped>
.item_sublinks {
  position: relative;
}

</style>